import { Component, effect, ElementRef, input, OnDestroy, ViewChild } from '@angular/core';

import Hls from 'hls.js';

@Component({
  selector: 'empathy-question-type-video',
  templateUrl: 'question-type-video.component.html',
  styleUrls: ['./question-type-video.component.scss']
})
export class QuestionTypeVideoComponent implements OnDestroy {
  @ViewChild('targetVideo', { static: true }) videoRef!: ElementRef;

  videoUrl = input<string>();

  private hls?: Hls;

  constructor() {
    effect(() => {
      const video = this.videoRef.nativeElement;

      if (Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.loadSource(this.videoUrl());
        this.hls.attachMedia(video);
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        // For Safari and iOS
        video.src = this.videoUrl();
      }
    });
  }

  ngOnDestroy(): void {
    this.hls?.destroy();
  }
}
